module.exports = __webpack_public_path__ + "static/media/manogu.cfe7cf4d.jpeg";